import { DOCUMENT_EXPORT_QUERY } from "@lib/graphql/queries";
import { useEffect } from "react";
import { useQuery } from "urql";

export type DocumentExportStatus = "pending" | "running" | "completed" | "failed";

export interface DocumentExportShape {
  id: string;
  status: DocumentExportStatus;
  kind: string;
  googleDocUrl: string | null;
  errorMessage: string | null;
}

// Polls a DocumentExport by id until it reaches a terminal status, then stops.
export function useDocumentExport(id: string | null) {
  const [{ data, fetching, error }, reexecute] = useQuery({
    query: DOCUMENT_EXPORT_QUERY,
    variables: id ? { id } : undefined,
    pause: !id,
    requestPolicy: "network-only",
  });

  const exportRow = (data?.documentExport ?? null) as DocumentExportShape | null;
  const isTerminal = exportRow?.status === "completed" || exportRow?.status === "failed";

  useEffect(() => {
    if (!id || isTerminal) return;
    const handle = window.setInterval(() => {
      reexecute({ requestPolicy: "network-only" });
    }, 2000);
    return () => window.clearInterval(handle);
  }, [id, isTerminal, reexecute]);

  return { exportRow, fetching, error };
}
